var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHoodIconRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 800,
    width: 800,
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    sodipodidocname: "no_hood_icon_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs90"
  }, /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "bspline",
    id: "path-effect3799",
    is_visible: "true",
    lpeversion: 1,
    weight: 33.333333,
    steps: 2,
    helper_size: 0,
    apply_no_weight: "true",
    apply_with_weight: "true",
    only_selected: "false"
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect7598",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect6640",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect6640-7",
    is_visible: "true",
    lpeversion: 1
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview88",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "true",
    inkscapezoom: 1,
    inkscapecx: 9,
    inkscapecy: 316,
    "inkscapewindow-width": 3440,
    "inkscapewindow-height": 1302,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent--layer": "Layer_1",
    inkscapelockguides: "false",
    showguides: "false"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid4969"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9356,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect2344",
    width: 345.7959,
    height: 230.53059,
    x: 84.047501,
    y: 45.386059,
    ry: 41.914658
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9356,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect2344-7",
    width: 275.19016,
    height: 130.2491,
    x: 118.61641,
    y: 76.822044,
    ry: 23.681658
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3808",
    transform: "matrix(1.6372911,0,0,1.6372911,-136.10921,-278.40461)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 9.78821,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect2344-8",
    width: 27.249599,
    height: 14.449579,
    x: 107.1504,
    y: 446.3504,
    ry: 7.2247896
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3206",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 10.3437,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 207.70901,338.46873 c -5.64396,0.36084 -11.29095,0.67548 -16.945,0.83125 -4.83276,0.13203 -9.67974,0.30661 -14.51875,0.24 a 16,16 0 0 0 -0.18125,2.22 16,16 0 0 0 16,16 16,16 0 0 0 16,-16 16,16 0 0 0 -0.355,-3.29125 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 8.60736,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 192,352 c 0,89.6 -57.6,102.4 -57.6,102.4",
    id: "path3803"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3808-9",
    transform: "matrix(-1.6372911,0,0,1.6372911,651.04802,-277.35675)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 9.78816,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect2344-8-2",
    width: 27.249599,
    height: 14.449579,
    x: 107.1504,
    y: 446.3504,
    ry: 7.2247896
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3206-9",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 10.3437,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 207.57776,338.00498 a 16,16 0 0 1 0.48625,3.755 16,16 0 0 1 -16,16 16,16 0 0 1 -16,-16 16,16 0 0 1 0.2975,-3 c 0.64787,-0.0137 1.29583,-0.0227 1.94375,-0.0387 4.55712,-0.10937 9.1134,-0.23428 13.67,-0.36375 5.2002,-0.14164 10.4026,-0.2077 15.6025,-0.3525 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 8.60736,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 192,352 c 0,89.6 -57.6,102.4 -57.6,102.4",
    id: "path3803-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 10.3437,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 320.70401,254.71998 h -25.6 l -19.2,-19.2 -38.4,38.4 -32,-19.2 h -44.8",
    id: "path3957"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 10.3437,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 314.30401,318.71998 h -32",
    id: "path3959"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 10.3437,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 205.50401,318.71998 h -32",
    id: "path3959-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHoodIconRed);
export default __webpack_public_path__ + "static/media/no_hood_icon_red.cfb3a043.svg";
export { ForwardRef as ReactComponent };